import { RiskPreference } from '../../../../../interfaces/open-choice/risk-preference.model';
import {
  RiskDescriptionEnum,
  RiskTypesEnum,
} from '../../../../../interfaces/open-choice/risk-quiz.enum';

export const mapRiskToDescription = (value: RiskTypesEnum): RiskDescriptionEnum => {
  switch (value) {
    case RiskTypesEnum.CONSERVATIVE:
      return RiskDescriptionEnum.VERY_CONSERVATIVE;
    case RiskTypesEnum.MODERATE_CONSERVATIVE:
      return RiskDescriptionEnum.CONSERVATIVE;
    case RiskTypesEnum.MODERATE:
      return RiskDescriptionEnum.MODERATE;
    case RiskTypesEnum.MODERATE_AGGRESSIVE:
      return RiskDescriptionEnum.AGGRESSIVE;
    case RiskTypesEnum.AGGRESSIVE:
      return RiskDescriptionEnum.VERY_AGGRESSIVE;
    default:
      return RiskDescriptionEnum.UNKNOWN;
  }
};
export const getRiskAttitude = (riskPreference: RiskPreference): RiskDescriptionEnum => {
  const { calculatedRiskTolerance, preferredRiskTolerance, defaultRiskTolerance } = riskPreference;

  const riskAttitude: RiskTypesEnum =
    preferredRiskTolerance || calculatedRiskTolerance || defaultRiskTolerance;

  return mapRiskToDescription(riskAttitude);
};
